import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { LoginTokenDataObject } from 'models/service';

export const getLoginToken = async () =>
  apiClient.get<LoginTokenDataObject, ApiClientResponse<LoginTokenDataObject>>(routes.user.loginToken);
